// extracted by mini-css-extract-plugin
export default {"box":"Box_box__p5Z99","dark":"Box_dark__2Ue6V"};